module.exports = __webpack_public_path__ + "static/how-to-create-contest__step-2-ee2a3be121ce4ca0c7986fefe733bd48.png";